import React from 'react';
import {Progress} from 'antd';
import {Row, Button, Divider, Text} from '../Widgets';

export default function UploadProgress({step, percentage}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}>
      <Text>
        {
          {
            0: '前置處理中',
            1: '前置處理中',
            2: '上傳檔案中',
            3: '更新稿件中',
          }[step]
        }
      </Text>
      <Progress percent={percentage} />
    </div>
  );
}

const metadata = {
  title: false,
  width: '200px',
};

export {metadata};
